import {
    ArrowRightIcon,
    IconCalendarPerson,
    IconCloseChip,
    PlusIconsOptions
} from '../../../../../../components/buttons/IconButtons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonActionsCard from '../../../../../../components/buttons/ButtonActionsCard';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';
import ZoneItem from './ZoneItem';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShiftsCard = (
    {
        workShiftAccessTime,
        workShift,
        setShowModal,
        onClickAdded = null,
        setWorkShift
    }
) => {
    const { t } = useTranslation();
    return (
        <>
            {workShift && workShiftAccessTime && workShiftAccessTime?.content?.length > 0 ?
                <>
                    <div className="card-shades-300-100 border-full-shades-300 border-radius-8px mb-4">
                        <div className="d-flex justify-content-between align-content-center p-2">
                            <div className="d-flex justify-content-start align-content-center">
                                <div><IconCalendarPerson className="icon-color-shades-950" width={16} height={16} /></div>
                                <p className="pl-3 fs-14px ibl-font-w-600 font-color-general-950">{t("i_entry_general_access")}</p>
                            </div>
                            <div>
                                <IconCloseChip
                                    className='icon-color-shades-400'
                                    onClick={()=>{
                                        setWorkShift(null);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="border-bottom-shades-300" />
                        <div className={"p-2"}>
                            {workShiftAccessTime?.content?.map((item, index) => (
                                <div className={`card-shades-200-100 border-full-shades-300 border-radius-8px p-2
                                ${ index === workShiftAccessTime?.content?.length ? "" : "mb-2"}`}
                                     id={`id_${item?.zoneId || index}`} key={`key_${item?.zoneId || index}`}>
                                    <ZoneItem
                                        item={item}
                                    />
                                </div>
                            ))}
                        </div>


                        {workShiftAccessTime?.totalElements >= 5 &&
                            <div className="d-flex justify-content-end py-3">
                                <ButtonActionsCard
                                    id='btn_wsc_show_full_schedules'
                                    name='show_full_schedules'
                                    iconProps='btn-icon-svg-12px icon-color-general-950'
                                    Icon={ArrowRightIcon}
                                    onClick={() => {
                                        setShowModal(true);
                                    }}
                                />
                            </div>
                        }
                    </div>
                </>
                : ''
            }

            <div className="d-flex justify-content-end pb-4 pb-sm-0">
                <ButtonAction
                    id='btn_wsc_add_work_shift'
                    name='add_work_shift'
                    className='btn-outlined-secondary-600-25'
                    Icon={PlusIconsOptions}
                    splitName={false}
                    disabled={!workShift}
                    onClick={() => {
                        if (onClickAdded) onClickAdded();
                    }}
                />
            </div>
        </>
    );
}

export default WorkShiftsCard
